import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-warm-950 text-white">
      <div className="px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <p className="font-display text-2xl font-bold tracking-tight mb-6">
              ITAOBUY <span className="text-tealwarm-400">SPREAD</span>
            </p>
            <p className="text-warm-200 text-sm leading-relaxed max-w-xs">
              Il punto di riferimento italiano per itaobuy spreadsheet. Trova prodotti selezionati, foto QC e guide complete per acquistare in modo più semplice e informato.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full border border-warm-700 flex items-center justify-center text-warm-300 hover:border-tealwarm-500 hover:text-tealwarm-400 transition-colors">
                <i className="ri-global-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full border border-warm-700 flex items-center justify-center text-warm-300 hover:border-tealwarm-500 hover:text-tealwarm-400 transition-colors">
                <i className="ri-shopping-bag-3-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full border border-warm-700 flex items-center justify-center text-warm-300 hover:border-tealwarm-500 hover:text-tealwarm-400 transition-colors">
                <i className="ri-information-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-warm-400 mb-6">Link Rapidi</p>
            <div className="space-y-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Itaobuy Sheet Completo</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Buy It Now</a>
              <Link to="/itaobuy-spreadsheet-guida-completa" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Guida Completa</Link>
              <Link to="/itaobuy-spreadsheet-come-usare" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Come Usare</Link>
              <Link to="/itaobuy-spreadsheet-sicurezza" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Sicurezza</Link>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-warm-400 mb-6">Categorie Popolari</p>
            <div className="space-y-3">
              <Link to="/itaobuy-spreadsheet-scarpe" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Scarpe</Link>
              <Link to="/itaobuy-spreadsheet-felpe" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Felpe / Maglioni</Link>
              <Link to="/itaobuy-spreadsheet-sneakers" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Sneakers</Link>
              <Link to="/itaobuy-spreadsheet-borse" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Borse</Link>
              <Link to="/itaobuy-spreadsheet-accessori" className="block text-sm text-warm-200 hover:text-tealwarm-400 transition-colors whitespace-nowrap">Accessori</Link>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-warm-400 mb-6">Disclaimer</p>
            <p className="text-warm-300 text-sm leading-relaxed">
              Questo sito fornisce informazioni e guide indipendenti su itaobuy spreadsheet. Non vendiamo direttamente prodotti. Gli utenti devono effettuare le proprie verifiche prima di qualsiasi acquisto. Tutti i marchi appartengono ai legittimi proprietari.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-warm-800">
        <div className="px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-warm-400">
            &copy; {new Date().getFullYear()} Itaobuy Spread. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-warm-400 hover:text-warm-200 transition-colors whitespace-nowrap">Privacy</Link>
            <Link to="/" className="text-xs text-warm-400 hover:text-warm-200 transition-colors whitespace-nowrap">Cookie</Link>
            <Link to="/" className="text-xs text-warm-400 hover:text-warm-200 transition-colors whitespace-nowrap">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}